(() => {
  const popup = document.getElementById('b2b-popup');
  if (!popup) return;

  const dialog = popup.querySelector('.b2b-popup__dialog');
  let lastActiveElement = null;

  const openPopup = () => {
    if (popup.classList.contains('is-open')) return;
    lastActiveElement = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    dialog?.focus();
  };

  const closePopup = () => {
    if (!popup.classList.contains('is-open')) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
    lastActiveElement = null;
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-b2b-popup-open]');
    if (openTrigger) {
      event.preventDefault();
      openPopup();
      return;
    }

    const closeTrigger = event.target.closest('[data-b2b-popup-close]');
    if (closeTrigger && popup.contains(closeTrigger)) {
      event.preventDefault();
      closePopup();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (!popup.classList.contains('is-open')) return;
    closePopup();
  });

  const autoOpen = () => {
    const hasHash = window.location.hash === '#b2b-popup';
    const hasSuccess = popup.querySelector('[data-b2b-popup-success]');
    const hasErrors = popup.querySelector('.b2b-popup__errors');
    if (hasHash || hasSuccess || hasErrors) {
      openPopup();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpen);
  } else {
    autoOpen();
  }
})();
